@if (withIcon) {
  <mat-icon svgIcon="icon-address" tiimeTooltip="Adresse"></mat-icon>
}
<span class="italic" tiimeFallbackText>
  @if (street) {
    @if (breakLine) {
      {{ street }}
      <br />
    } @else {
      {{ street }},
    }
  }
  {{ postalCode }} {{ city }}
</span>
